/**
 * Base-scale resolver for the theme builder.
 *
 * The active brand's OKLCH scales are baked (theme/generated/activeBrandScales.js, keyed off the
 * brand's configs/_shared colors); this module just hands the theme builder (themes.js) the light
 * and dark base-scale objects. Brand identity lives entirely in the baked scales + ACTIVE_META — no
 * per-brand palette objects or literal token overrides anymore (the hero derives; see themes.js).
 *
 * Pure data + pure functions only (matches @learnzapp/core's platform-agnostic contract).
 */
import { getBaseScales } from './baseScales';

/**
 * Resolve the active brand into the { L, D } base-scale objects the theme builder consumes.
 * @returns {{L: Object, D: Object}}  light + dark baseColors-shaped family maps.
 */
export function resolveBase() {
  return { L: getBaseScales('light'), D: getBaseScales('dark') };
}
